// extracted by mini-css-extract-plugin
export var container = "header-module--container--nMwLv";
export var img = "header-module--img--jLk7x";
export var logo = "header-module--logo--DrXJI";
export var tagline = "header-module--tagline--NjV2v";